import { openBlock as t, createElementBlock as c, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(n, e) {
  return t(), c("svg", o, [...e[0] || (e[0] = [
    l("g", { "clip-path": "url(#a)" }, [
      l("path", {
        fill: "currentColor",
        d: "m3.391 2.729.576-.006q.938-.004 1.876.006l1.31-.002q1.368 0 2.738.01c1.169.008 2.338.006 3.507.002q1.35-.003 2.701.003h1.293q.904-.001 1.808.01l.538-.005c1.165.022 1.764.264 2.582 1.093.296.593.277.998.286 1.661l.012.745q.016 1.689.026 3.376.006.891.02 1.782.018 1.282.022 2.566l.016.804c-.003 1.128-.016 1.82-.615 2.796-.994.588-1.756.583-2.892.547l-.624-.005a148 148 0 0 1-1.966-.037l-1.336-.016A310 310 0 0 1 12 18v1.44h4.56v1.68H6v-1.68h4.32V18l-.818.019q-1.506.032-3.013.047-.651.009-1.302.024-.937.021-1.875.027l-.586.019c-.935 0-1.429-.078-2.248-.565-.73-1.176-.654-2.27-.646-3.629l-.005-.841q-.002-.88.003-1.76c.005-.898-.005-1.795-.015-2.693l.002-1.71-.011-.813.011-.76.002-.666c.217-.743.57-1.125 1.187-1.587.763-.408 1.543-.397 2.385-.383M1.68 4.8q-.009 2.403-.013 4.806l-.005 1.637-.005 2.346-.004.744v.684l-.002.606c-.021.46-.021.46.269.697.583.024 1.159.033 1.742.031l.552.001h5.709q1.694-.002 3.387 0a1604 1604 0 0 0 3.845 0h2.27c.795.066.795.066 1.455-.272.025-.344.033-.688.035-1.033l.005-.665v-.724l.003-.738.001-1.549q.002-1.188.01-2.376l.001-1.502.006-.722-.003-.667.001-.589c-.017-.53-.017-.53-.539-.955a19 19 0 0 0-1.721-.058l-.537-.002q-.882 0-1.762.005h-1.221q-1.281 0-2.562.006-1.644.006-3.288.004a1263 1263 0 0 0-3.735.005q-.847.001-1.693.005h-.51c-.875-.005-.875-.005-1.691.275"
      })
    ], -1),
    l("defs", null, [
      l("clipPath", { id: "a" }, [
        l("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
